import { useState, useEffect } from 'react';

function Gallery({ images = [], onImageSelect }) {
  const [expandedImage, setExpandedImage] = useState(null);

  // If there are no images, don't render anything
  if (images.length === 0) return null;
  
  // Add CSS for hiding scrollbar
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .hide-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }`;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="w-full">
      <h3 className="text-sm font-medium text-gray-700 mb-1 px-1">Recent Transformations:</h3>
      
      {/* Gallery grid - horizontal scrolling */}
      <div className="flex overflow-x-auto pb-2 gap-2 hide-scrollbar">
        {images.slice(0, 10).map((image, index) => (
          <div 
            key={image.id || index}
            className="flex-none w-16 h-16 bg-white rounded-md shadow-sm overflow-hidden cursor-pointer hover:shadow-md border border-gray-200"
            onClick={() => setExpandedImage(image)}
          >
            <img 
              src={image.url} 
              alt={`Gallery image ${index + 1}`} 
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Full-size image modal */}
      {expandedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setExpandedImage(null)}
        >
          <div 
            className="relative max-w-md max-h-[80vh] bg-white rounded-lg shadow-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 bg-white bg-opacity-75 rounded-full p-1 z-10"
              onClick={() => setExpandedImage(null)}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <img 
              src={expandedImage.url} 
              alt="Expanded gallery image" 
              className="w-full h-full object-contain"
            />
            
            <div className="bg-white p-3 border-t">
              <p className="font-medium text-sm">{expandedImage.style || 'Transformed Image'}</p>
              
              <div className="mt-2 flex justify-end space-x-3">
                <button
                  className="text-secondary text-xs underline"
                  onClick={() => {
                    if (onImageSelect) onImageSelect(expandedImage);
                    setExpandedImage(null);
                  }}
                >
                  Use This Image
                </button>
                <a
                  href={expandedImage.url}
                  download={`cartoon-pfp-${(expandedImage.style || 'image').toLowerCase().replace(/\s+/g, '-')}.png`}
                  className="bg-accent text-gray-800 px-3 py-0.5 text-xs rounded font-medium hover:bg-yellow-400"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery; 